import { Browser } from '@capacitor/browser';

// Opens an external URL in the in-app browser on iOS/Android. On the web,
// Capacitor's Browser implementation falls back to window.open(url, '_blank'),
// so the same call works on every platform.
export const openExternalUrl = async (url: string): Promise<void> => {
  await Browser.open({ url });
};
